import React from "react";
import { useApolloClient } from "react-apollo";

import { Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const logout = client => {
  localStorage.clear();
  localStorage.clear();
  client.writeData({
    data: {
      authStatus: {
        __typename: "authStatus",
        status: "loggedOut"
      }
    }
  });
  window.location.href = "/";
};

const LogoutButton = () => {
  const client = useApolloClient();
  return (
    <Button outlined color="danger" onClick={() => logout(client)}>
      <Icon size="small">
        <FontAwesomeIcon icon="sign-out-alt" />
      </Icon>
      <span>Logout</span>
    </Button>
  );
};

export default LogoutButton;
